import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function PengajuanPinjam() {
  const { id, npp } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [listBesarPlafond, setListBesarPlafond] = useState([
    { label: "Rp.1.000.000", value: 1000000 },
    { label: "Rp.2.000.000", value: 2000000 },
    { label: "Rp.3.000.000", value: 3000000 },
    { label: "Rp.4.000.000", value: 4000000 },
    { label: "Rp.5.000.000", value: 5000000 },
    { label: "Rp.6.000.000", value: 6000000 },
    { label: "Rp.7.000.000", value: 7000000 },
    { label: "Rp.8.000.000", value: 8000000 },
    { label: "Rp.9.000.000", value: 9000000 },
    { label: "Rp.10.000.000", value: 10000000 },
    { label: "Rp.11.000.000", value: 11000000 },
    { label: "Rp.12.000.000", value: 12000000 },
    { label: "Rp.13.000.000", value: 13000000 },
    { label: "Rp.14.000.000", value: 14000000 },
    { label: "Rp.15.000.000", value: 15000000 },
  ]);
  const [listLamaCicilan, setListLamaCicilan] = useState([
    { label: "3 - Bulan", value: 3 },
    { label: "6 - Bulan", value: 6 },
    { label: "9 - Bulan", value: 9 },
    { label: "12 - Bulan", value: 12 },
    { label: "18 - Bulan", value: 18 },
    { label: "24 - Bulan", value: 24 },
  ])
  const [empBesarPlafond, setEmpBesarPlafond] = useState([]);
  const [empLamaCicilan, setEmpLamaCicilan] = useState(0);
  const [empSetorPlafond, setEmpSetorPlafond] = useState([]);
  const [empSetorTotal, setEmpSetorTotal] = useState([]);
  const [empJrate, setEmpJRate] = useState([]);
  const [empData, setEmpData] = useState([]);
  const [jrateData, setJRateData] = useState([]);
  const [checkPinjaman, setCheckPinjaman] = useState();
  const [newData, setNewData] = useState({
    plafond: "",
    lama:0,
    cpokok: "",
    cicilan: "",
    jasa_bulan: "",
  });


  // CONTROLLER

  const fetchData = async (id) => {
    setIsLoading(true);

      await axios
      .all(
        [
        baseAPI .get(`/v1/user/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/jrate`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/statuspinjaman/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
        ]
      )
      .then((res) => {
        const dataUser = res[0].data.data.userData;       
        const dataJrate = res[1].data.data.jrate;      
        const checkPinjaman = res[2].data.data.pinjaman;
        
        let check;
        if (checkPinjaman.length > 0) {
          check = (checkPinjaman[0].cpokok * checkPinjaman[0].cicilan_ke) < (checkPinjaman[0].plafond * 0.5) ? "Disabled" : "Enable";
        }

        setCheckPinjaman(check);
        setEmpData(dataUser[0]);
        setJRateData(dataJrate);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const storeNewPinjaman = async (id) => {
    Swal.fire({
      title: 'Apakah data pengajuan pinjaman anda sudah benar?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Ajukan',
      denyButtonText: `Jangan Ajukan`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        const body = new FormData();
        body.append('new_data', JSON.stringify(newData));

        baseAPI
          .post(`/v1/detailpinjam/${id}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Data pengajuan pinjaman berhasil diajukan.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
            setEmpBesarPlafond([]);
            setEmpLamaCicilan(0);
            setNewData({
              plafond: "",
              lama:0,
              cpokok: "",
              jasa_bulan: "",
            })
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Data pengajuan tabungan gagal diajukan.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchData(id);
          })
      } else if (result.isDenied) {
        Swal.fire('Silahkan periksa ulang data pengajuan anda.', '', 'info')
      }
    });

  }

  const checkCicilanPlafond = async (lama, plafond) => {
  
    if (plafond <= 10000000) {
      setListLamaCicilan([
        { label: "3 - Bulan", value: 3 },
        { label: "6 - Bulan", value: 6 },
        { label: "9 - Bulan", value: 9 },
        { label: "12 - Bulan", value: 12 },
      ])
    } else {
      setListLamaCicilan([
        { label: "3 - Bulan", value: 3 },
        { label: "6 - Bulan", value: 6 },
        { label: "9 - Bulan", value: 9 },
        { label: "12 - Bulan", value: 12 },
        { label: "18 - Bulan", value: 18 },
        { label: "24 - Bulan", value: 24 },
      ])
    }

    if (lama > 12) {
      setListBesarPlafond([
        { label: "Rp.11.000.000", value: 11000000 },
        { label: "Rp.12.000.000", value: 12000000 },
        { label: "Rp.13.000.000", value: 13000000 },
        { label: "Rp.14.000.000", value: 14000000 },
        { label: "Rp.15.000.000", value: 15000000 },
      ])
    } else {
      setListBesarPlafond([
        { label: "Rp.1.000.000", value: 1000000 },
        { label: "Rp.2.000.000", value: 2000000 },
        { label: "Rp.3.000.000", value: 3000000 },
        { label: "Rp.4.000.000", value: 4000000 },
        { label: "Rp.5.000.000", value: 5000000 },
        { label: "Rp.6.000.000", value: 6000000 },
        { label: "Rp.7.000.000", value: 7000000 },
        { label: "Rp.8.000.000", value: 8000000 },
        { label: "Rp.9.000.000", value: 9000000 },
        { label: "Rp.10.000.000", value: 10000000 },
        { label: "Rp.11.000.000", value: 11000000 },
        { label: "Rp.12.000.000", value: 12000000 },
        { label: "Rp.13.000.000", value: 13000000 },
        { label: "Rp.14.000.000", value: 14000000 },
        { label: "Rp.15.000.000", value: 15000000 },
      ])
    }

    if (lama !== 0) {
      let cpokok = 0;
      let cicilan = 0;
      let rupiahCpokok = 0;
      let rupiahJasa = 0;
      let rupiahCicilan = 0;
  
      let matchedRate = null;
  
      // Find the matching rate
      jrateData.some(e => {
        if (e.plafond === plafond && e.tenor === lama) {
          matchedRate = e;
          return true; // Stop iterating after the first match
        }
        return false;
      });
  
      if (matchedRate) {
        cpokok = (plafond / lama).toFixed(0);
        cicilan = (matchedRate.jasa_bulan + (plafond / lama)).toFixed(0);
  
        rupiahCpokok = parseFloat(cpokok).toLocaleString('id-ID');
        rupiahJasa = parseFloat(matchedRate.jasa_bulan).toLocaleString('id-ID');
        rupiahCicilan = parseFloat(cicilan).toLocaleString('id-ID');
  
        // Use the functional form of setNewData to ensure you're working with the latest state
        setNewData(prevData => ({
          ...prevData,
          jasa_bulan: matchedRate.jasa_bulan,
          cicilan: cicilan,
          cpokok: cpokok
        }));
  
        setEmpSetorPlafond("Rp." + rupiahCpokok);
        setEmpJRate("Rp." + rupiahJasa);
        setEmpSetorTotal("Rp." + rupiahCicilan);
      }
    }
  };
  
  
  useEffect(() => {
    // if (user.role === ANGGOTA) {
      fetchData(user.id);
    // };
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Pinjaman Tunai</Link> /{' '}
              <Link to='/tunai/pengajuanpinjam' style={{ color: '#333' }}>Pengajuan Pinjaman Tunai</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Formulir Pengajuan Pinjaman</b></p>
                <p>Silahkan mengisi formulir pengajuan pinjaman berikut untuk mengajukan pinjaman.</p>
              </div>

              {/* Besar plafond */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Besar Plafond
                </label>
                <Select
                  options={listBesarPlafond}
                  defaultValue={listBesarPlafond && empBesarPlafond}
                  placeholder="Pilih besar plafond"
                  onChange={e => {
                    setEmpBesarPlafond(e);
                    setNewData(prevData => ({ ...prevData, plafond: e.value }));
                    checkCicilanPlafond(newData.lama, e.value);
                  }}
                />
              </div>

              {/* Lama cicilan plafond */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Lama Cicilan
                </label>
                <Select
                  isDisabled={newData.plafond !== "" ? false : true}
                  options={listLamaCicilan}
                  defaultValue={listLamaCicilan && empLamaCicilan}
                  placeholder="Pilih item"
                  onChange={e => {
                    setEmpLamaCicilan(e.value);
                    setNewData(prevData => ({ ...prevData, lama: e.value }));
                    checkCicilanPlafond(e.value, empBesarPlafond.value);
                  }}
                />
              </div>

              {/* Tanggal pengajuan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pengajuan
                </label>
                <DatePicker
                  selected={moment().utcOffset(7, true).toDate()}
                  placeholderText="Pilih tanggal"
                  className="form-control datepicker"
                  readOnly
                  dateFormat="dd/MM/yyyy"
                />
              </div>

              {/* Name */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Name
                </label>
                <input
                  defaultValue={empData.name_anggota}
                  placeholder='Employee name'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Besar jasa per bula */}
              <div className='col-md-4 mb-3' hidden>
                <label htmlFor='true' className='form-label'>
                  Besar Jasa per Bulan
                </label>
                <input
                  defaultValue={empJrate}
                  placeholder='Besar jasa bulan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Cicilan Pokok per bulan */}
              <div className='col-md-4 mb-3' hidden>
                <label htmlFor='true' className='form-label'>
                  Cicilan Pokok per Bulan
                </label>
                <input
                  defaultValue={empSetorPlafond}
                  placeholder='Cicilan pokok per bulan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Cicilan Total (jasa + pokok) per bulan */}
              <div className='col-md-12 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Cicilan Total per Bulan
                </label>
                <input
                  defaultValue={empSetorTotal}
                  placeholder='Cicilan total per bulan'
                  className="form-control"
                  readOnly
                />
              </div>
              
              {checkPinjaman === "Disabled" ?
                <p className="font-weight-bold text-danger">Maaf anda tidak bisa mengajukan pinjaman, karena anda masih memiliki pinjaman dan pembayaran cicilan anda masih lebih kecil dari 1/2 tenor.</p>
              :
                <div className='col-md-12'>
                  <button
                    disabled={newData.lama !== 0 && newData.plafond !== "" && newData.cpokok !== "" && newData.jasa_bulan !== "" ? false : true}
                    type="button"
                    className='btn btn-danger col-md-12'
                    style={{backgroundColor: "#9681EB"}}
                    onClick={() => storeNewPinjaman(user.id)}
                  >
                    Ajukan
                  </button>
                </div>
              }

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default PengajuanPinjam;